import { IApolloSearchPartnersResult } from 'legacy/lut/classes/models/apollo'

import { apolloApi } from 'onboarding/api/apolloApi'

import { IApolloSearchGuestParameters } from '../classes/models/iApolloSearchGuest'

class ApolloService {
  public search(parameters: IApolloSearchGuestParameters): Promise<IApolloSearchPartnersResult[]> {
    return apolloApi.search(parameters)
  }
}

export const apolloService = new ApolloService()
